import React, { useState } from 'react';
import ClosedDialer from './ClosedDialer';
import DialerPopup from './DialerPopup';
import { useDialerContext } from '../DialerContext';

const DialerController = ( { caseContacts } ) => {
	const { isOpen, handleClose, handleOpen } = useDialerContext();
	const [ firstRender, setFirstRender ] = useState( true );

	if ( !isOpen ) {
		return (
			<ClosedDialer handleOpen={handleOpen} firstRender={firstRender} setFirstRender={setFirstRender} />
		);
	}

	return (
		<DialerPopup 
			handleClose={handleClose}
			caseContacts={caseContacts}
		/>
	);
};

export default DialerController;